import { range } from 'ramda'
import React from 'react'

import { Col, Grid } from '../structure/Grid'
import { HOUR_HEIGHT } from './_helpers/conflict'
import { Relative } from '../helpers/Position'
import { useCalendar } from './CalendarHandler'
import HourlyEvent from './HourlyEvent'
import HourlyPlaceholder from './HourlyPlaceholder'
import Line from '../helpers/Line'
import Text, { SmallText } from '../presentation/Text'

const HOURS = range(0, 24)

const WeekView = () => {
  const { perspective, daysOfWeek, onSelectDay, handleSelectEmptyTime, onSelectEvent } = useCalendar()
  if (perspective !== 'week') return false

  return (
    <>
      <Grid wrap>
        <Col width="4.1%" />
        {daysOfWeek.map(item => (
          <Col width="13.7%" padding={0.4} key={item.index}>
            <SmallText size="xxxsmall" align="center" bold color="dark5" onClick={() => onSelectDay(item.date)}>
              {item.date.format('dddd')} ({item.day})
            </SmallText>
          </Col>
        ))}
      </Grid>

      {HOURS.map(hour => (
        <div key={hour}>
          <Line />
          <Grid>
            <Col width="4.1%" align="center" justify="center" direction="row">
              <Line vertical />
              <Col flex={1}>
                <Text align="center">{hour}:00</Text>
              </Col>
              <Line vertical />
            </Col>
            {daysOfWeek.map(item => (
              <Col width="13.7%" key={item} direction="row">
                <Col flex={1} height={HOUR_HEIGHT} onClick={() => handleSelectEmptyTime(hour, item.date)}>
                  <HourlyPlaceholder />
                  <Relative zIndex={0}>
                    {item.events.map(event => (
                      <HourlyEvent key={event.id} event={event} hour={hour} onClick={() => onSelectEvent(event)} />
                    ))}
                  </Relative>
                </Col>
                <Line vertical />
              </Col>
            ))}
          </Grid>
          <Line />
        </div>
      ))}
    </>
  )
}

export default WeekView
